/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationCompanyQuery = gql`
  query GetSimulationCompanyQuery {
    getSimulationCompany_simulation_company {
      company {
 name  
siren  
siret  
addresses {
 fields  
zipCode  
city  
department  
} 
legalForm  
ccnRef  
history {
 name  
siret  
department  
} 
ccnHasAgreement  
}
    }
  }
`;

export default GetSimulationCompanyQuery;
